import { axiosInstanceIservices } from 'lib/services/config/axios-config'
import { useQuery } from 'react-query'
import { TRestResponse } from 'lib/services/restApi/restApi.types'
import { OrganizationSurgeryReportsResponse } from './types'
import { useAuth0 } from 'app/Auth'

const getOrganizationReports = async (
  surgeryId: string,
  token: string
): Promise<TRestResponse<OrganizationSurgeryReportsResponse>> => {
  const response = await axiosInstanceIservices.get<
    TRestResponse<OrganizationSurgeryReportsResponse>
  >('/surgery-report-templates/get-organization-reports', {
    params: {
      surgeryId,
    },
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })
  return response.data
}

export const useGetOrganizationReports = (surgeryId: string) => {
  const { getAccessToken } = useAuth0()

  return useQuery<
    TRestResponse<OrganizationSurgeryReportsResponse>,
    Error,
    OrganizationSurgeryReportsResponse
  >(['organizationReports'], async () => {
    const token = await getAccessToken()
    return getOrganizationReports(surgeryId, token)
  })
}
